import * as React from 'react'
import styled from 'styled-components'

import * as S from '../../styles'

export type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement>

function CheckboxComponent({
    className,
    ...inputProps
}: CheckboxProps): React.ReactElement<CheckboxProps> {
    return (
        <S.form.checkbox.Wrapper className={className} disabled={inputProps?.disabled}>
            <S.form.checkbox.HiddenFocusableInput type="checkbox" {...inputProps} />
            <S.form.checkbox.Container>
                {/*
                    NOTE: We do not use `icons.Check` since the line stroke width is bolder here.
                    This bolder variant resides here for now as its purpose is limited to the Checkbox.
                */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 12 10"
                    width="10px"
                >
                    <path
                        d="M9.9929.7929l1.4142 1.4142-7.1237 7.1238L.6596 5.7071 2.0738 4.293 4.2827 6.502z"
                        fill="currentColor"
                        fillRule="nonzero"
                    />
                </svg>
            </S.form.checkbox.Container>
        </S.form.checkbox.Wrapper>
    )
}
export const Checkbox = styled(CheckboxComponent)``
